import { useDispatch, useSelector } from 'react-redux';
import {
  getProductId,
  getTotalNumberOfReviews,
  productInfoSelector,
  productTagSelector,
  productUsps,
  selectTacticalFlagColor,
  selectTacticalFlagMessage
} from 'views/ProductPage/selector';
import { ReviewStats } from 'views/ProductPage/reviews/themes/BGH/reviewStats';
import { IconCheckmark } from 'components/Shared/Icon/themes/PP/iconCheckmark';
import { ProductTitle } from '../BGH/productInfoHeader';
import { ProductTag } from 'components/Tag';
import { useAccordionContext } from 'components/Accordion/context';
import { REVIEWS_ID } from 'views/ProductPage/reviews';
import styles from './header.scss';
import { isMobile } from 'components/Shared/responsive';
import { NO_ELEMENT, withCurrentPage } from 'utils';
import { TacticalFlag } from 'components/TacticalFlag';
import { GtmCopyProductTitle } from 'store/googleTagManager/actions';

export const Header = () => {
  return (
    <div className={styles.header}>
      <Reviews />
      <Title />
      <USPS />
    </div>
  );
};

const Reviews = () => {
  const tag = useSelector(productTagSelector);
  const tacticalFlagMarking = useSelector(selectTacticalFlagMessage);
  const tacticalFlagColor = useSelector(selectTacticalFlagColor);
  const haveReviews = useSelector(getTotalNumberOfReviews);
  const { openReview } = useAccordionContext();

  return (
    <div className={styles.reviews}>
      {haveReviews > 0 && (
        <a href={`#${REVIEWS_ID}`} onClick={openReview}>
          <ReviewStats starRatingClassName={styles.rating} />
        </a>
      )}
      <ProductTag type={tag} appearance="small" />
      <TacticalFlag
        tacticalFlagMarking={tacticalFlagMarking}
        tacticalFlagColor={tacticalFlagColor}
        appearance="small"
      />
    </div>
  );
};

const Title = () => {
  const reduxDispatch = useDispatch();
  const mobile = useSelector(isMobile);
  const titleProps = useSelector(productInfoSelector);
  const productId = useSelector(withCurrentPage(getProductId));

  const onCopy = () => {
    reduxDispatch(GtmCopyProductTitle(titleProps.title, productId));
  };

  return (
    <div className={styles.title}>
      <ProductTitle {...titleProps} mobile={mobile} handleCopy={onCopy} />
    </div>
  );
};

const USPS = () => {
  const usps = useSelector(productUsps);

  if (usps === undefined || usps.length === 0) {
    return NO_ELEMENT;
  }

  return (
    <div>
      {usps.map(usp => (
        <div key={usp} className={styles.usp}>
          <IconCheckmark size="tiny" className={styles.icon} />
          {usp}
        </div>
      ))}
    </div>
  );
};
